/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{display:inline-block}.share-container[_ngcontent-%COMP%]   .share-icons[_ngcontent-%COMP%]     .jssocials-share-link{border:none}\n/*# sourceMappingURL=social.share.component.css.map*/"];
export { styles as styles };
